import { GetCustomerResponse } from '@ar/network/AccountsReceivable.network';
import { ChargeOnValues } from '@ar/components/CustomerDetails/AutoPayAndCardSettings/AutoPayAndCardSettings.constants';

export const normalizeCustomer = (customer: GetCustomerResponse): GetCustomerResponse => {
    const clonedCustomer = { ...customer };
    const chargeInvoiceWhen = Object.keys(ChargeOnValues).find((key) => ChargeOnValues[key] === clonedCustomer.charge_invoice_when);
    clonedCustomer.charge_invoice_when = chargeInvoiceWhen;
    return clonedCustomer;
};
